import React, { useEffect, useState } from 'react';
import './payment-iframe.scss';
import Button from '../Button/Button';
import ButtonEnum from '../Button/ButtonEnum';
import { PaymentEventListenerEnum } from '../../../views/pages/Payment/payment-event-listener.enum';
import { toast } from 'react-toastify';
import {
  useModalUnmountCallback,
  useModalUnmountCallbackThunk,
  useSetUnmountModalCallback,
} from '../../../store/modal/modalHooks';
import { useTranslation } from 'react-i18next';

interface PaymentIframeProps {
  url?: string;
  backText?: string;
  onClickBack?: () => void;
  onPaymentSuccess: () => void;
}

const PaymentIframe = (props: PaymentIframeProps) => {
  const unmountCallback = useModalUnmountCallbackThunk();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const messageListener = (event: {
    origin: string;
    data: { action: string; status: number };
  }) => {
    if (
      event.origin === 'https://meshulam.co.il' ||
      event.origin === 'https://sandbox.meshulam.co.il' ||
      event.origin === 'https://secure.meshulam.co.il'
    )
      switch (event?.data?.action) {
        case 'payment':
          if (event?.data?.status) {
            props.onPaymentSuccess();
          } else {
            toast.error(`Payment failed`);
            unmountCallback().finally();
          }
          break;
        default:
          toast.error(`Payment failed`);
          if (props.onClickBack) {
            props.onClickBack();
          }
      }
  };

  useEffect(() => {
    window.addEventListener('message', messageListener);

    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);

  useEffect(() => {
    // Function to make the text appear instantly
    const displaySlowLoadingText = () => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 3000); // 3000 milliseconds (3 seconds) delay before disappearing
    };

    displaySlowLoadingText();
  }, []);

  return (
    <div className="payment-iframe">
      <div className="payment-iframe-title">{t('SELECT_CREDIT_CARD')}</div>
      {props.url && <iframe src={props.url} height="310px"></iframe>}
      <h1 className={isVisible ? 'red-notice' : 'fade-out'}>
        {t('SLOW_LOADING_FORM')}
      </h1>
      {props.backText && props.onClickBack && (
        <Button
          className="iframe-back-button"
          type={ButtonEnum.GREY_LIGHT}
          onClick={props.onClickBack}
          text={props.backText}
        />
      )}
    </div>
  );
};

export default PaymentIframe;
